module.exports = {"131071450":"耀华道街道","131071451":"云鹏道街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131071.json
// module id = 240
// module chunks = 0